import React, { useEffect } from 'react';
import {
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { connect } from 'react-redux';
import Layout from './components/Layout/layout';
import { IUser } from './shared/models/adminModels';

// Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-notifications-component/dist/theme.css'
import './style.css';
import './App.css';

// Pages
import Login from './pages/Login';
import MainRoute from './routes';
import ToastNotification from './components/Toast';
import ForgotPassword from './pages/Login/forgotPassword';
import ResetPassword from './pages/Login/resetPassword';
import Loader from './components/Loader';
import { checkIsLoggedIn } from './store/actions/auth';
import ErrorComponent from './pages/errorComponent';

interface IProps {
  isError: boolean;
  isLoggedIn: boolean;
  user: IUser;
  checkIsLoggedIn: Function;
}

const App = (props: IProps) => {
  const { isLoggedIn, checkIsLoggedIn } = props;

  useEffect(() => {
    checkIsLoggedIn();
  }, []);

  const { user } = props
  return isLoggedIn != null ? (<>
    {
      !isLoggedIn ?
        <>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <Redirect to="/login" />
          </Switch>
          <Loader></Loader>
        </>
        :
        <>
          {props.isError ? <ErrorComponent></ErrorComponent> :
            <Layout>
              <MainRoute  loggedInUser={user}/>
              <Loader></Loader>
            </Layout>}
        </>

    }
    <ToastNotification></ToastNotification>
  </>
  ) : <></>;
}

const mapStateToProps = (state: any) => ({
  isError: state.common.isError,
  isLoggedIn: state.auth.isLoggedIn,
  user: state.auth.user
});

const mapDispatchToProps = (dispatch: any) => ({
  checkIsLoggedIn: () => dispatch(checkIsLoggedIn())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
